module.exports = __webpack_public_path__ + "media/images/front/clinicwiki/logo-0924729dad568ea83c9bab2f46f4076d.png";